import {addDoc, collection, limit, onSnapshot, orderBy, query} from 'firebase/firestore';
import {db} from '../../../shared/services/firebase';
import {fail, logError, ok, toConfigError} from './apiHelpers';

/**
 * Subscribe to the most recent lifecycle entries (max 5).
 * Returns the unsubscribe function.
 */
export const subscribeToLifecycle = (edgeId, onData, onError) => {
  const q = query(
    collection(db, 'edges', edgeId, 'lifecycle'),
    orderBy('created', 'desc'),
    limit(5)
  );
  return onSnapshot(
    q,
    (snap) => {
      const history = [];
      snap.forEach((s) => history.push(s.data()));
      onData(history);
    },
    (error) => {
      console.error('[configApi:subscribeToLifecycle]', error);
      onError?.(error);
    }
  );
};

/**
 * Add a new lifecycle status entry.
 */
export const addLifecycleEntry = async (edgeId, status, comment) => {
  try {
    await addDoc(collection(db, 'edges', edgeId, 'lifecycle'), {
      status,
      comment,
      created: new Date(),
    });
    return ok();
  } catch (error) {
    const errorInfo = toConfigError(error, 'CONFIG_SAVE_FAILED');
    logError('addLifecycleEntry', errorInfo);
    return fail(errorInfo);
  }
};

